import UpgradePremiumModal from './UpgradePremiumModal'

export default UpgradePremiumModal
